import { css } from "@emotion/react";

export const styles = {
  filterIcon: css`
    --icon-fill-color: var(--color-splash-primary);
  `,
  legacyFullWidthButton: css`
    display: flex;
    flex: 1;

    > button {
      flex: 1;
    }
  `
};
